import { ProfileIconIndicator } from 'common/components/ProfileIcon/ProfileIconIndicator/ProfileIconIndicator.component';
import { ProfileIconSvg } from 'common/components/ProfileIcon/ProfileIconSvg/ProfileIconSvg.component';

import { useCustomer } from 'common/hooks';
import { VerificationLevelStates } from 'common/hooks/useCustomer/useCustomer.constants';

import './index.css';

export const ProfileIcon = () => {
  const { intermediateVerificationLevelStatus } = useCustomer();

  return (
    <div className='profile-icon'>
      {intermediateVerificationLevelStatus.verificationLevelState === VerificationLevelStates.NOT_APPROVED && (
        <ProfileIconIndicator />
      )}
      <ProfileIconSvg />
    </div>
  );
};
